import { useSelector } from "react-redux";
import PlUpgrade from "../Mycomponent/pages/login/plUpgrade";
import PlLogin from "../Mycomponent/pages/login/plLogin";
import PlAdd from "../Mycomponent/pages/login/plAdd";

const ProtectedRoute = ({
  isPlanRequire,
  isLoginRequire,
  isProjectRequire,
  children,
}) => {
  const isLogin = useSelector((state) => state.loginout);
  const isPlan = useSelector((state) => state.isplan);
  const isproject = useSelector((state) => state.isproject);

  if (isLoginRequire && !isLogin) {
    return <PlLogin />;
  }
  if (isProjectRequire && !isproject) {
    return <PlAdd />;
  }
  if (isPlanRequire && !isPlan) {
    return <PlUpgrade />;
  }

  return children;
};

export default ProtectedRoute;
